import * as React from 'react';
import { IAccUser, IApiError } from '../../api/ApiClient';
import {
    InputText, LoaderBtn, PhoneInput, VerifyEmailInput,
} from 'components';
import { useForm, useLoading } from 'hooks';
import { RegExpConst, RegExpErrorsText } from '_helpers';
import { Button } from 'react-bootstrap';

const initDetails: FormType = {
    middleName: '',
    lastName: '',
    firstName: '',
    phone: '',
    email: '',
};

const validateRules = {
    phone: { regexp: RegExpConst.PHONE, errorText: RegExpErrorsText.PHONE, required: true },
    email: { regexp: RegExpConst.EMAIL, errorText: RegExpErrorsText.EMAIL, required: true },
    firstName: { regexp: RegExpConst.NAME, errorText: RegExpErrorsText.NAME, required: true },
    lastName: { regexp: RegExpConst.NAME, errorText: RegExpErrorsText.NAME, required: true },
    middleName: { regexp: RegExpConst.NAME, errorText: RegExpErrorsText.NAME, required: true },
    position: { errorText: RegExpErrorsText.REQUIRED, required: true },
};

type FormKeyType = Exclude<keyof IAccUser, 'emailConfirmed' | 'id' | 'accreditationCenterId'>;

type FormType = Record<FormKeyType, string>;

const UserEditor: React.FC<IProps> = (props) => {
    const [form, errors, changeField, setForm, handleSubmit, setErrors] = useForm<FormType>(props.details || initDetails, validateRules);
    const [processing, submit] = useLoading((f: FormType) => props.onSubmit(f));

    React.useEffect(() => {
        if (props.details) {
            setForm(props.details);
        }
    }, [props.details]);

    React.useEffect(() => {
        if (props.apiError) {
            setErrors(props.apiError);
        }
    }, [props.apiError]);

    const renderInput = (
      title: string,
      placeholder: string,
      name: FormKeyType,
    ) => (
      <InputText
        autoComplete={name === 'phone' ? 'tel-national' : undefined}
        type={name === 'phone' ? 'tel' : undefined}
        labelTitle={title}
        prependContent={name === 'phone' ? '+7' : undefined}
        placeholder={placeholder}
        name={name}
        value={form ? String(form[name]) : ''}
        fieldFailures={{ [name]: errors[name] || '' }}
        onChange={changeField}
        labelColSize={2}
        inputColSize={10}
      />
    );

    const renderPhoneInput = (
      title: string,
      placeholder: string,
      name: FormKeyType,
    ) => (
      <PhoneInput
        autoComplete="tel-national"
        labelTitle={title}
        placeholder={placeholder}
        value={form ? String(form[name]) : ''}
        fieldFailures={{ [name]: errors[name] || '' }}
        phoneHelperClassName="pl-3"
        onChange={changeField}
        labelColSize={2}
        inputColSize={10}
      />
    );

    const renderEmailInput = (
      title: string,
      placeholder: string,
      name: FormKeyType,
    ) => (
      <VerifyEmailInput
        value={form ? String(form[name]) : ''}
        fieldFailures={{ [name]: errors[name] || '' }}
        onChange={changeField}
        sendConfirmationEmail={props.onSendConfirmation}
        labelColSize={2}
        inputColSize={10}
        triggerText="Перевыслать письмо"
      />
    );


    return (
      <section>
          {renderInput('ИМЯ', 'Укажите имя', 'firstName')}
          {renderInput('ФАМИЛИЯ', 'Укажите фамилию', 'lastName')}
          {renderInput('ОТЧЕСТВО', 'Укажите отчество', 'middleName')}
          {/* {renderInput('ДОЛЖНОСТЬ', 'Укажите должность', 'position')} */}
          {renderPhoneInput('ТЕЛЕФОН', 'Укажите номер телефона', 'phone')}
          {renderEmailInput('ПОЧТА', 'Укажите адрес электронной почты', 'email')}

          <div className="d-flex">
              <LoaderBtn
                onClick={() => handleSubmit(submit)}
                variant="primary"
                loading={processing || props.processing}
                className="mr-4"
              >
                  {props.accessBtnTittle || 'Сохранить'}
              </LoaderBtn>
              <Button onClick={props.onCancel} variant="outline-secondary">Отмена</Button>
          </div>
      </section>
    );
};

interface IProps {
    details: FormType | null;
    onSubmit: (form: FormType) => Promise<void>;
    onSendConfirmation?: () => void;
    onCancel: () => void;
    accessBtnTittle: string;
    processing?: boolean;
    apiError: IApiError | null;
}

export default UserEditor;
